import React from 'react';
import { Table } from 'antd';
import NoDataState from '../../../RnRCommonComponent/noDataState/NoDataState.jsx';
import uuid from 'uuid/v4';

const ApprovalRewardsTable = (props) => {
  const { approvedData, columns, isLoading, emptyMessage, rowKey } = props;
  
  return (
    <div className="nomination-rewards-table table-card">
      <Table
        rowKey={rowKey || ((record) => uuid() + record.id)}
        dataSource={approvedData}
        columns={columns}
        loading={isLoading}
        rowHoverable={false}
        rowSelectedHoverBg={"white"}
        pagination={{ pageSize: 25, showSizeChanger: false }}
        locale={{ emptyText: <NoDataState title={emptyMessage || "No data available"} /> }}
      />
    </div>
  );
};

export default ApprovalRewardsTable;
